import { z } from 'zod';

/**
 * Integrations: OrderHub's link from one venue to an outside system the venue runs its business on
 * (Square). Core code names the role an integration plays for a venue (menu source, receiver),
 * never the integration itself; `convex/integrations/domain.ts` translates one to the other. Terms,
 * naming rules and how to add or remove one: root `AGENTS.md`, "Integrations".
 */
export const INTEGRATION_NAMES = ['SQUARE'] as const;
export const zIntegrationName = z.literal(INTEGRATION_NAMES);
export type IntegrationName = z.output<typeof zIntegrationName>;

/** How UI copy names each integration ("This menu comes from Square."). */
export const INTEGRATION_LABELS: Record<IntegrationName, string> = {
  SQUARE: 'Square',
};
